export interface TransportationModel {
  transportationCode: string;
  transportationName: string;
}
export interface TransportationState {
  transportationList: TransportationModel[];
}

export abstract class TransportationCodeConst {
  public static Ghtk = "Ghtk";
  public static ViettelPost = "ViettelPost";
  public static Ghn = "Ghn";
  public static Customize = "Customize";
}

export interface GhtkSettingModel {
  token: string;
  isSandbox: boolean;
  isActive: boolean;
}
